<script>
import { api } from "@/api";
import RegisterSteps from "../../components/auth/RegisterSteps.vue";
import eventBus from "@/shared/eventBus";
import TurnStile from "@/components/TurnStileVue2.vue";
const fields = [
  [
    "usr_username",
    "usr_email",
    "usr_password",
    "usr_confirm_password",
    "usr_name",
    "usr_org_full_name",
    "usr_phone_number",
    "usr_phone_number1",
    "usr_phone_number2",
    "usr_phone_number3",
    "usr_country",
    "usr_address",
    "usr_region",
    "usr_zip_code"
  ],
  [
    "usr_tax_info",
    "usr_business_register",
    "org_pib",
    "usr_org_registration_number",
    "usr_org_bank",
    "usr_org_contact_person",
    "business_activiti",
    "org_services",
    "org_type",
    "org_id",
    "org_contact",
    "usr_pr_text"
  ],
  ["socials"]
];
export default {
  components: { TurnStile, RegisterSteps },
  data() {
    return {
      localToken: "",
      resetToken: false,
      user: {
        usr_email: null,
        usr_username: null,
        usr_org_full_name: null,
        usr_password: null,
        usr_phone_number: null,
        usr_phone_number1: null,
        usr_phone_number2: null,
        usr_phone_number3: null,
        usr_address: null,
        usr_postal_code: null,
        usr_region: null,
        usr_country: null,
        org_pib: null,
        usr_business_register: null,
        usr_tax_info: null,
        usr_name: null,
        org_services: null, // postaje string
        business_activiti: null,
        // Type of business organization
        org_type: null,
        org_id: null,
        org_contact: null,
        usr_org_contact_person: null,
        usr_org_registration_number: null,
        usr_org_bank: null,
        usr_notifications: false,
        usr_newsletter: false,
        usr_private: false,
        usr_pr_text: null,
        socials: []
      },
      errors: {},
      usernameTaken: false,
      emailTaken: false,
      pibTaken: false,
      idTaken: false,
      countries: [],
      organisationType: [],
      organisationServices: [],
      socials: [],
      rules: false
    };
  },
  computed: {
    isBusiness() {
      return this.$route.query.type === "business";
    }
  },
  mounted() {
    this.getCountries();
    this.getOrganisationType();
    this.getSocials();
  },
  methods: {
    async getCountries() {
      try {
        const response = await api.getCountries();
        for (const el of response.data.data) {
          this.countries.push({
            label: el.cnt_name,
            value: el.cnt_id
          });
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    },
    async getOrganisationType() {
      try {
        const response = await api.getOrganisationType();
        for (const el of response.data.data) {
          this.organisationType.push({
            label: el.otp_name,
            value: el.otp_id
          });
        }
      } catch (error) {
        console.error("Error fetching organisation types:", error);
      }
    },
    async getSocials() {
      try {
        const response = await api.getSocialTypes();
        this.socials = response.data.data;
      } catch (error) {
        console.error("Error fetching socials:", error);
      }
    },
    async register() {
      if (this.user.usr_pr_text && this.user.usr_pr_text.length > 1100) {
        this.errors.usr_pr_text = true;
        return;
      }
      if (!this.rules) {
        this.$toast.error(this.$t("errors.registration.rules"), {
          duration: 8000
        });
        return;
      }
      // await this.$recaptchaLoaded();
      // const token = await this.$recaptcha("login");
      const params = Object.assign({}, this.user);
      if (params.usr_country) {
        params.usr_country = params.usr_country.value;
      }
      // if (params.org_services) {
      //   params.org_services = this.user.org_services.value
      // }
      // Type of business organization
      if (this.isBusiness) {
        params.type = "org";
      } else {
        params.type = "usr";
      }
      if (params.org_type) {
        params.org_type = this.user.org_type.value;
      }

      if (params.socials) {
        const filteredSocials = params.socials.filter(
          social => social.link !== ""
        );
        params.socials = JSON.stringify(filteredSocials);
      }
      params.token = this.localToken;
      this.resetToken = !this.resetToken;

      this.fixEmptyStrings(params);
      let formData = new FormData();
      for (var variable in params) {
        if (params.hasOwnProperty(variable)) {
          formData.append(variable, params[variable]);
        }
      }
      eventBus.$emit("showLoader", true);
      try {
        const res = await api.register(formData);
        if (res) {
          this.$toast.success(this.$t("toast.registerSuccess"), {
            duration: 8000
          });
          this.user = {
            usr_email: null,
            usr_username: null,
            usr_org_full_name: null,
            usr_password: null,
            usr_phone_number: null,
            usr_phone_number1: null,
            usr_phone_number2: null,
            usr_phone_number3: null,
            usr_address: null,
            usr_postal_code: null,
            usr_region: null,
            usr_country: null,
            org_pib: null,
            usr_business_register: null,
            usr_tax_info: null,
            usr_name: null,
            org_services: null, // postaje string
            business_activiti: null,
            // Type of business organization
            org_type: null,
            org_id: null,
            org_contact: null,
            usr_org_contact_person: null,
            usr_org_registration_number: null,
            usr_org_bank: null,
            usr_notifications: false,
            usr_newsletter: false,
            usr_private: false,
            usr_pr_text: null,
            socials: []
          };
        }
      } catch (e) {
        this.handleErrors(e.response);
      } finally {
        eventBus.$emit("showLoader", false);
      }
    },
    handleErrors(response) {
      if (response.data.hasOwnProperty("missing")) {
        for (var i = 0; i < response.data.missing.length; i++) {
          this.$set(this.errors, response.data.missing[i], true);
        }
        this.$toast.error(this.$t("errors.registration.missing"), {
          duration: 8000
        });
      }
      if (response.data.hasOwnProperty("invalid")) {
        for (i = 0; i < response.data.invalid.length; i++) {
          this.$set(this.errors, response.data.invalid[i], true);
        }
        this.$toast.error(this.$t("errors.registration.invalid"), {
          duration: 8000
        });
      }
      if (response.data.hasOwnProperty("same")) {
        for (i = 0; i < response.data.same.length; i++) {
          if (response.data.same[i] === "usr_username") {
            this.usernameTaken = true;
            this.$toast.error(this.$t("errors.registration.usernameTaken"), {
              duration: 8000
            });
          } else if (response.data.same[i] === "usr_email") {
            this.emailTaken = true;
            this.$toast.error(this.$t("errors.registration.emailTaken"), {
              duration: 8000
            });
          } else if (response.data.same[i] === "org_pib") {
            this.pibTaken = true;
            this.$toast.error(this.$t("errors.registration.pibTaken"), {
              duration: 8000
            });
          } else if (response.data.same[i] === "org_id") {
            this.idTaken = true;
            this.$toast.error(this.$t("errors.registration.idTaken"), {
              duration: 8000
            });
          }
        }
      }
      this.handleNav();
    },
    handleNav() {
      for (const index in fields) {
        for (const field of fields[index]) {
          if (this.errors[field]) {
            const page = "RegisterPage" + (Number(index) + 1);
            this.$router.push({
              name: page,
              params: { lang: this.$i18n.locale },
              query: {
                type: this.isBusiness ? "business" : "user"
              }
            });
            return;
          }
        }
      }
    },
    fixEmptyStrings(obj) {
      for (var variable in obj) {
        if (obj.hasOwnProperty(variable)) {
          if (
            obj[variable] === "" ||
            obj[variable] === null ||
            obj[variable].length === 0
          ) {
            delete obj[variable];
          }
        }
      }
      return obj;
    },
    clearError(field, socialTypeId) {
      if (field === "socials" && socialTypeId) {
        this.$delete(this.errors, socialTypeId);
      }
      if (this.errors.hasOwnProperty(field)) {
        this.$delete(this.errors, field);
      }
    },
    setToken(e) {
      this.localToken = e;
    },
    // handleNext(val) {
    //   this.$router.push()
    // }
    updateSocials(event) {
      // Object.assign({}, this.socials, event); not reactive
      //  this.socials = event; reactive
      this.user.socials = event;
    }
  }
};
</script>
<template>
  <div class="page-help">
    <RouterLink
      :to="{ name: 'Home', params: { lang: $i18n.locale } }"
      class="home-link"
    >
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="svg-back"
      >
        <path
          d="M3.52375 6.8813L7.99375 2.14871L6.81525 0.90097L0.333418 7.76359L6.81525 14.6261L7.99375 13.3784L3.52375 8.64588H13.6667V6.8813H3.52375Z"
          fill="#E7E9EA"
        />
      </svg>
      <span>{{ $t("backToStart") }}</span></RouterLink
    >

    <div v-if="isBusiness" class="reg-hero">
      <h2>{{ $t("main.registrationBusiness") }}</h2>
      <div class="txt">{{ $t("register.registerTxtBusiness") }}</div>
    </div>
    <div v-else class="reg-hero">
      <h2>{{ $t("main.registrationStandard") }}</h2>
      <div class="txt">{{ $t("register.registerTxtStandard") }}</div>
    </div>
    <RegisterSteps />
    <KeepAlive>
      <router-view
        :user="user"
        :errors="errors"
        :type="isBusiness"
        :countries="countries"
        :organisation-type="organisationType"
        :socials="socials"
        :token="localToken"
        :rules="rules"
        @clear-error="clearError"
        @update-socials="updateSocials"
        @update="user = Object.assign({}, user, $event)"
        @register="register"
        @change-rules="rules = $event"
      >
      </router-view>
    </KeepAlive>
    <TurnStile :resetToken="resetToken" @set-token="setToken" />
    <div v-html="$t('main.recaptchaWarn')" class="recaptcha-warn"></div>
  </div>
</template>
<style lang="scss" scoped>
.page-help {
  text-align: left;
}
#register-wrap {
  max-width: 1320px;
  margin: 0 auto;
}
.home-link {
  font-weight: 500;
  font-style: Medium;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0%;
  color: $gray-blue-700;
  text-decoration: none;
  display: inline-block;
  margin-bottom: 36px;
  span {
    margin-left: 7px;
  }
}
.home-link:hover {
  color: $blue-400;
  .svg-back > path {
    fill: $blue-400 !important;
  }
}
.reg-hero {
  width: 100%;
  max-width: 637px;

  h2 {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;

    line-height: 100%;
    letter-spacing: 0%;
    color: $blue-1000;
    margin-top: 0;
    margin-bottom: 25px;
  }
  .txt {
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0%;
    color: $blue-400;
    margin-bottom: 41px;
  }
}
@media only screen and (max-width: 768px) {
  .reg-hero {
    h2 {
      font-size: 30px;
      line-height: 100%;

      margin-bottom: 15px;
    }
    .txt {
      font-size: 16px;
      line-height: 20px;

      margin-bottom: 31px;
    }
  }
}
</style>
